const STORAGE_KEYS = {
  family: "dahrendorf_family",
  trips: "dahrendorf_trips",
  suggestions: "dahrendorf_suggestions",
  packingLists: "dahrendorf_packing_lists",
};

const DEFAULT_FAMILY = [
  { id: "f1", name: "Lukas", role: "parent", emoji: "\u{1F468}", color: "#264653", avatar_url: "https://customer-assets.emergentagent.com/job_2b2386c2-84ba-4ac6-aaff-7fc29c17627e/artifacts/h54hss2g_Lukas.jpeg" },
  { id: "f2", name: "Laura", role: "parent", emoji: "\u{1F469}", color: "#E76F51", avatar_url: "https://customer-assets.emergentagent.com/job_2b2386c2-84ba-4ac6-aaff-7fc29c17627e/artifacts/i1e6nwmw_Laura.jpeg" },
  { id: "f3", name: "Louie", role: "child", emoji: "\u{1F466}", color: "#2A9D8F", avatar_url: "https://customer-assets.emergentagent.com/job_2b2386c2-84ba-4ac6-aaff-7fc29c17627e/artifacts/qweag9iu_Louie.jpg" },
  { id: "f4", name: "Levi", role: "child", emoji: "\u{1F466}", color: "#E9C46A", avatar_url: "https://customer-assets.emergentagent.com/job_2b2386c2-84ba-4ac6-aaff-7fc29c17627e/artifacts/jneoby5a_Levi.jpeg" },
  { id: "f5", name: "Noah", role: "child", emoji: "\u{1F466}", color: "#F4A261", avatar_url: "https://customer-assets.emergentagent.com/job_2b2386c2-84ba-4ac6-aaff-7fc29c17627e/artifacts/y6swu8gc_Noah.jpg" },
];

const DEFAULT_TRIPS = [
  {
    id: "t1",
    title: "USA Westküste 2026 - Family Road Trip",
    description: "26-tägiger Familien-Roadtrip für Lukas, Laura, Louie, Levi & Noah.\n\n\u{1F5D3}️ 17. Juli - 11. August 2026\n\n\u{1F4CD} ROUTE:\n• Tag 1-3: Las Vegas (Bellagio) - Strip, Grand Canyon Helikopter\n• Tag 4-6: Los Angeles (Marina del Rey) - Universal Studios VIP, Hollywood\n• Tag 7-8: Sequoia NP (Wuksachi Lodge) - General Sherman Tree\n• Tag 9-10: Yosemite NP (The Ahwahnee) - El Capitan, Half Dome\n• Tag 11-12: San Francisco (Argonaut Hotel) - Alcatraz, Golden Gate\n• Tag 13: Benbow KOA (29.-30. Jul)\n• Tag 14-15: Crescent City KOA / Redwoods (30. Jul-1. Aug)\n• Tag 16: Bullards Beach SP, Oregon (1.-2. Aug)\n• Tag 17: Waldport/Newport KOA (2.-3. Aug)\n• Tag 18: Astoria KOA Resort (3.-4. Aug)\n• Tag 19: La Push (Quileute Resort) - Olympic Coast\n• Tag 20-21: Port Angeles (Crescent Beach) - Olympic NP\n• Tag 22: Seattle (Sound Hotel) - RV-Rückgabe\n• Tag 23-24: Leavenworth (Berg Haus, 8.-10. Aug)\n• Tag 25-26: Seattle (Hotel 1000) - Space Needle, Heimreise",
    location: "Las Vegas → Seattle (USA Westküste)",
    latitude: 39.5,
    longitude: -119.5,
    start_date: "2026-07-17",
    end_date: "2026-08-11",
    status: "planned",
    photos: [{ id: "p1", url: "https://images.unsplash.com/photo-1605833556294-ea5c7a74f57d?w=800&q=80", caption: "Las Vegas" }],
    created_at: "2026-01-01T00:00:00.000Z",
  },
];

const DEFAULT_SUGGESTIONS = [
  {
    id: "s1", title: "Mount St. Helens",
    description: "Der Vulkan, dessen Nordseite 1980 weggesprengt wurde - eine Explosion 500-mal stärker als Hiroshima! Johnston Ridge Observatory mit Blick direkt in den Krater.",
    location: "Mount St. Helens, Washington", latitude: 46.1914, longitude: -122.1956, duration: "1 Tag",
    image_url: "https://customer-assets.emergentagent.com/job_family-travel-hub/artifacts/34y8hl7i_IMG_2693.jpeg",
    highlights: ["Johnston Ridge Observatory", "Blick in den Krater", "Interaktive Ausstellungen", "Umgestürzte Baumstämme"],
    is_extension: false, added_to_trip: false,
  },
  {
    id: "s2", title: "Leavenworth - Little Bavaria",
    description: "Ein komplettes bayerisches Dorf mitten in den Cascade Mountains! Fachwerkhäuser, Biergärten, Brezeln - als wärt ihr in Garmisch gelandet.",
    location: "Leavenworth, Washington", latitude: 47.5962, longitude: -120.6615, duration: "1-2 Tage",
    image_url: "https://customer-assets.emergentagent.com/job_family-travel-hub/artifacts/e9libzqo_IMG_2692.jpeg",
    highlights: ["Bayerische Biergärten", "Nussknacker-Museum", "Tubing am Wenatchee River", "Wandern in den Cascades"],
    is_extension: false, added_to_trip: false,
  },
  {
    id: "s3", title: "Yellowstone National Park",
    description: "Der älteste Nationalpark der Welt - sitzt auf einem Supervulkan! Old Faithful, Grand Prismatic Spring, Mammoth Hot Springs und wilde Tiere.",
    location: "Yellowstone National Park, Wyoming", latitude: 44.428, longitude: -110.5885, duration: "+4-5 Tage",
    image_url: "https://customer-assets.emergentagent.com/job_family-travel-hub/artifacts/95zuar5m_IMG_2694.webp",
    highlights: ["Old Faithful Geysir", "Grand Prismatic Spring", "Mammoth Hot Springs", "Bisons im Lamar Valley", "Junior Ranger Badge"],
    is_extension: true, added_to_trip: false,
  },
  {
    id: "s4", title: "Bar J Chuckwagon",
    description: "Legendäre Cowboy-Dinner-Show auf einer echten Ranch. Deftiges Chuckwagon-Essen (BBQ, Steaks, Bohnen, Biscuits) auf Blechtellern, danach eine geniale Live-Show mit den Bar J Wranglers – echte Cowboys mit Western-Musik, Comedy und Yodeling.",
    location: "Wilson/Jackson Hole, Wyoming", latitude: 43.4799, longitude: -110.8752, duration: "1 Abend",
    image_url: "https://customer-assets.emergentagent.com/job_2b2386c2-84ba-4ac6-aaff-7fc29c17627e/artifacts/bjnbg562_IMG_2698.jpeg",
    highlights: ["BBQ & Steaks auf Blechtellern", "Live-Show mit Bar J Wranglers", "Western-Musik & Comedy", "Echte Ranch-Atmosphäre", "Seit über 40 Jahren Familientradition"],
    is_extension: false, added_to_trip: false,
  },
];

const DEFAULT_PACKING_LISTS = [
  {
    id: "pl1", title: "USA Westküste 2026 - Packliste", trip_id: "t1",
    items: [
      { id: "i1", name: "Reisepässe für alle 5", checked: false, category: "dokumente" },
      { id: "i2", name: "ESTA Genehmigungen", checked: false, category: "dokumente" },
      { id: "i3", name: "Führerschein (international)", checked: false, category: "dokumente" },
      { id: "i4", name: "Kreditkarten", checked: false, category: "dokumente" },
      { id: "i5", name: "Auslandskrankenversicherung (Nachweis)", checked: false, category: "dokumente" },
      { id: "i6", name: "Buchungsbestätigungen (Hotels/KOA/Mietwagen)", checked: false, category: "dokumente" },
      { id: "i7", name: "Kopien aller Dokumente (digital + Papier)", checked: false, category: "dokumente" },
      { id: "i8", name: "Wanderschuhe (5x)", checked: false, category: "kleidung" },
      { id: "i9", name: "Regenjacken (5x)", checked: false, category: "kleidung" },
      { id: "i10", name: "Badekleidung (5x)", checked: false, category: "kleidung" },
      { id: "i11", name: "Sonnenhüte/Caps (5x)", checked: false, category: "kleidung" },
      { id: "i12", name: "Lange Hosen für Wanderungen", checked: false, category: "kleidung" },
      { id: "i13", name: "Fleece-/Softshelljacken (abends kühl)", checked: false, category: "kleidung" },
      { id: "i14", name: "Flip-Flops/Sandalen", checked: false, category: "kleidung" },
      { id: "i15", name: "Kamera + Ladegerät", checked: false, category: "elektronik" },
      { id: "i16", name: "Tablets für Autofahrten (3x)", checked: false, category: "elektronik" },
      { id: "i17", name: "Fernglas (Wildtiere!)", checked: false, category: "elektronik" },
      { id: "i18", name: "Powerbanks + USB-C Kabel", checked: false, category: "elektronik" },
      { id: "i19", name: "US-Steckdosenadapter (3x)", checked: false, category: "elektronik" },
      { id: "i20", name: "Kopfhörer für Kinder (3x)", checked: false, category: "elektronik" },
      { id: "i21", name: "Handy-Halterung fürs Auto", checked: false, category: "elektronik" },
      { id: "i22", name: "Sonnencreme LSF 50", checked: false, category: "toilettenartikel" },
      { id: "i23", name: "Reiseapotheke (Ibuprofen, Pflaster, Fieberthermometer)", checked: false, category: "toilettenartikel" },
      { id: "i24", name: "Insektenschutz", checked: false, category: "toilettenartikel" },
      { id: "i25", name: "After-Sun Lotion", checked: false, category: "toilettenartikel" },
      { id: "i26", name: "Zahnbürsten + Zahnpasta", checked: false, category: "toilettenartikel" },
      { id: "i27", name: "Junior Ranger Hefte", checked: false, category: "kinder" },
      { id: "i28", name: "Reisetagebücher (3x, für Louie/Levi/Noah)", checked: false, category: "kinder" },
      { id: "i29", name: "Buntstifte + Filzstifte", checked: false, category: "kinder" },
      { id: "i30", name: "Kuscheltiere", checked: false, category: "kinder" },
      { id: "i31", name: "Kartenspiele / Reisespiele", checked: false, category: "kinder" },
      { id: "i32", name: "Snacks für Autofahrten", checked: false, category: "essen" },
      { id: "i33", name: "Trinkflaschen (5x)", checked: false, category: "essen" },
      { id: "i34", name: "Tagesrucksack für Wanderungen", checked: false, category: "sonstiges" },
      { id: "i35", name: "Picknickdecke", checked: false, category: "sonstiges" },
      { id: "i36", name: "Taschenlampe/Stirnlampe", checked: false, category: "sonstiges" },
      { id: "i37", name: "Reise-Waschmittel", checked: false, category: "sonstiges" },
      { id: "i38", name: "Erste-Hilfe-Set fürs Auto", checked: false, category: "sonstiges" },
    ],
    created_at: "2026-01-01T00:00:00.000Z",
  },
];

function load(key, defaults) {
  try {
    const stored = localStorage.getItem(key);
    if (stored) return JSON.parse(stored);
  } catch { /* ignore */ }
  localStorage.setItem(key, JSON.stringify(defaults));
  return defaults;
}

function save(key, data) {
  localStorage.setItem(key, JSON.stringify(data));
}

const localApi = {
  getFamily: () => Promise.resolve({ data: load(STORAGE_KEYS.family, DEFAULT_FAMILY) }),
  createFamilyMember: (member) => {
    const family = load(STORAGE_KEYS.family, DEFAULT_FAMILY);
    const newMember = { ...member, id: `f-${Date.now()}` };
    family.push(newMember);
    save(STORAGE_KEYS.family, family);
    return Promise.resolve({ data: newMember });
  },
  deleteFamilyMember: (id) => {
    let family = load(STORAGE_KEYS.family, DEFAULT_FAMILY);
    family = family.filter((m) => m.id !== id);
    save(STORAGE_KEYS.family, family);
    return Promise.resolve({ data: { message: "Deleted" } });
  },

  getTrips: () => Promise.resolve({ data: load(STORAGE_KEYS.trips, DEFAULT_TRIPS) }),

  getSuggestions: () => Promise.resolve({ data: load(STORAGE_KEYS.suggestions, DEFAULT_SUGGESTIONS) }),
  toggleSuggestion: (id) => {
    const suggestions = load(STORAGE_KEYS.suggestions, DEFAULT_SUGGESTIONS);
    const sug = suggestions.find((s) => s.id === id);
    if (sug) {
      sug.added_to_trip = !sug.added_to_trip;
      save(STORAGE_KEYS.suggestions, suggestions);
      return Promise.resolve({ data: { message: "Toggled", added_to_trip: sug.added_to_trip } });
    }
    return Promise.reject(new Error("Not found"));
  },

  getPackingLists: () => Promise.resolve({ data: load(STORAGE_KEYS.packingLists, DEFAULT_PACKING_LISTS) }),
  createPackingList: (list) => {
    const lists = load(STORAGE_KEYS.packingLists, DEFAULT_PACKING_LISTS);
    const newList = { ...list, id: `pl-${Date.now()}`, items: list.items || [], created_at: new Date().toISOString() };
    lists.push(newList);
    save(STORAGE_KEYS.packingLists, lists);
    return Promise.resolve({ data: newList });
  },
  updatePackingList: (id, data) => {
    const lists = load(STORAGE_KEYS.packingLists, DEFAULT_PACKING_LISTS);
    const idx = lists.findIndex((l) => l.id === id);
    if (idx >= 0) {
      lists[idx] = { ...lists[idx], ...data, id };
      save(STORAGE_KEYS.packingLists, lists);
      return Promise.resolve({ data: lists[idx] });
    }
    return Promise.reject(new Error("Not found"));
  },
  deletePackingList: (id) => {
    let lists = load(STORAGE_KEYS.packingLists, DEFAULT_PACKING_LISTS);
    lists = lists.filter((l) => l.id !== id);
    save(STORAGE_KEYS.packingLists, lists);
    return Promise.resolve({ data: { message: "Deleted" } });
  },
  togglePackingItem: (listId, itemId) => {
    const lists = load(STORAGE_KEYS.packingLists, DEFAULT_PACKING_LISTS);
    const list = lists.find((l) => l.id === listId);
    if (list) {
      const item = list.items.find((i) => i.id === itemId);
      if (item) {
        item.checked = !item.checked;
        save(STORAGE_KEYS.packingLists, lists);
        return Promise.resolve({ data: { message: "Toggled" } });
      }
    }
    return Promise.reject(new Error("Not found"));
  },
};

export default localApi;
